module.exports = __webpack_public_path__ + "static/img/lx-bg-1.5d92775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lx-bg-1.jpg
// module id = Cebw
// module chunks = 1